import { NumberField, OrmModel } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import { BaseReportingHistoricalTableModel } from '@/data/models/domain/reporting/common/types'

@OrmModel(modelNames.REPORTING_EMAIL_TREND)
export default class ReportingEmailTrend extends BaseReportingHistoricalTableModel {
  @NumberField()
  public sent: number

  @NumberField()
  public deliveryRate: number

  @NumberField()
  public openRate: number

  @NumberField()
  public clickRate: number

  @NumberField()
  public bounceRate: number

  @NumberField()
  public unsubscribeRate: number

  @NumberField()
  public spamRate: number

  @NumberField()
  public costs: number
}
